export default __webpack_public_path__ + "static/media/CL02.1.9b593022.mp3";